jQuery(function($){
    setTimeout(function(){
        jQuery('a[href="https://accessibe.com/blog/knowledgebase/screen-reader-guide"]').attr('aria-label','Screen Reader Guide');
        /*/remove incorrect roles*/
        jQuery('img').each(function(){
          jQuery(this).removeAttr('role');
        });
        jQuery('label').each(function(){
          jQuery(this).removeAttr('role');
        });
        jQuery('.ot-cookie').each(function(){
          jQuery(this).removeAttr('aria-level');
        });
        jQuery('.navigation--layout-button').each(function(){
          jQuery(this).attr('role','region');
        });
      jQuery('a[aria-controls="x-menu--sub-shop"]').each(function(){
        var myTarget = jQuery(this);
        jQuery(this).parent().find('a').each(function(){
          
          jQuery(this).on('keydown', function(e){
          if(e.key === 'Escape'){
            e.preventDefault();
            //myTarget.parent().next().focus();
            jQuery('a[href="/collections/tops"]').focus();
          }
        });
        });
        
      });
        },2500);

     setTimeout(function(){
	//begin updates to alternate text, title, and aria-label if needed only
	//begin updates to alternate text, title, and aria-label if needed only
	var imgCnt = 1;
	  var proImg = 1;
	  var mobProImg = 1;
	  var relProImg = 1;
	 // var nextImgCnt = 1;
	var h1PrdTxt = jQuery('h1').html() ? jQuery('h1').html() : jQuery("title").html();
	  
	jQuery('img').each(function () {
		var curAlt = jQuery(this).attr('alt');
		var curTitle = jQuery(this).attr('title');
		var curAriaLbl = jQuery(this).attr('aria-label');
		var curImgLinkTitle = jQuery(this).parent('a').attr('title');
		var curImgPrnts = jQuery(this).parents().map(function () {
			return this.tagName;
		})
			.get()
			.join(', ');
		var myCurImg = jQuery(this);
		var frogs = false; //product images
		var lizards = false;//mobile product images
		var snakes = false;//related product images
		//var nxtPrvNav = false;// navigation images
		jQuery('#product-photos').find('img').each(function () {
				if (jQuery(this) === myCurImg) {
					frogs = true;
				} else { frogs = false;}
		});
		jQuery('#mobile-product').find('img').each(function () {
			if (jQuery(this) === myCurImg) {
				lizards = true;
			}
          else {
            lizards = false;
          }
		});
		jQuery('#related').find('img').each(function () {
			if (jQuery(this) === myCurImg) {
				snakes = true;
			} else {
              snakes = false;
            }
		});
		/*jQuery('#product-navigation').find('img').each(function () {
			if (jQuery(this) === myCurImg) {
				nxtPrvNav = true;
			}
		});*/

		//no alt text or empty alt text or undefined
		if (!curAlt || curAlt === '' || curAlt === 'undefined') {
			jQuery(this).attr('alt', ''); //decorative	
			//link check without alt text
			if (curImgPrnts.includes('A,') || curImgPrnts.includes(' A ')) {
				//desktop view contains links within the slide show so we check
				if (frogs) {
					jQuery(this).attr('alt', 'Product Image #' + proImg + ' for ' + h1PrdTxt);
					//update product slide count
					proImg++;
				}
				else if (lizards) {
					jQuery(this).attr('alt', 'Product Image #' + mobProImg + ' for ' + h1PrdTxt);
					//update slide count
					mobProImg++;
  
                } else 	if (snakes) {
                if(curAlt.includes(curImgLinkTitle))
                {
                  curImgLinkTitle = 'related product image #' + relProImg;
                }
				//related products
				/*jQuery(this).attr('alt', curImgLinkTitle ? curImgLinkTitle : 'related product image #' + relProImg);*/
              jQuery(this).attr('alt',  'related product image #' + relProImg);
				relProImg++;
			}
				else { //else not in desktop product gallery
					jQuery(this).attr('alt', 'Image link #' + imgCnt);
				}
			} else {
				//Check for Mobile product slides as they are not links but are informative
				//mobile view slides without alt text
				if (lizards) {
					jQuery(this).attr('alt', 'Product Image #' + mobProImg + ' for ' + h1PrdTxt);
					//update slide count
					mobProImg++;
				} else { //standard behavior
					//if empty then should not contain title or aria-label
					jQuery(this).removeAttr('aria-label');
					jQuery(this).removeAttr('title');
				}//end standard behavior
			}//end link check

		} else {
			//alt present so we should leave alt alone
			jQuery(this).attr('alt', curAlt);
			//if title present add an aria-label as well
			if (!curTitle || curTitle === '' || curTitle === 'undefined') {

			}
			else {
				/*Add title back in*/
				jQuery(this).attr('title', curTitle);
				//first check to make sure it doesn't already have aria-label
				if (!curAriaLbl || curAriaLbl === '' || curAriaLbl === 'undefined') {
					jQuery(this).attr('aria-label', curTitle);
				} else {
					/*add it back in*/
					jQuery(this).attr('aria-label', curAriaLbl);
				}
			}
			/* we can leave the above alone but if these are product images we need to make sure they are */
			/* not just repeating the product name becoming redundant alt text */
			if (frogs) {
				//now check for duplicate text
				if (curAlt === h1PrdTxt) {//so if equal we need to update it
					jQuery(this).attr('alt', 'Product Image #' + proImg + ' for ' + h1PrdTxt);
					//update product slide count
					proImg++;
                }//end check for duplicate text.
			};//end desktop slides
			if (lizards) {
				if (curAlt === h1PrdTxt) {//so if equal we need to update it
					jQuery(this).attr('alt', 'Product Image #' + mobProImg + ' for ' + h1PrdTxt);
					//update slide count
					mobProImg++;
				}//end check for duplicate text.
			} //end mobile slides
			//related images
			if (snakes) {
                if(curAlt.includes(curImgLinkTitle))
                {
                  curImgLinkTitle = 'related product image #' + relProImg;
                }
				//related products
				/*jQuery(this).attr('alt', curImgLinkTitle ? curImgLinkTitle : 'related product image #' + relProImg);*/
              jQuery(this).attr('alt',  'related product image #' + relProImg);
				relProImg++;
			}
		}//end main if
      if (frogs) {
				//now check for duplicate text
				if (curAlt === h1PrdTxt) {//so if equal we need to update it
					jQuery(this).attr('alt', 'Product Image #' + proImg + ' for ' + h1PrdTxt);
					//update product slide count
					proImg++;
                }//end check for duplicate text.
			};//end desktop slides
			if (lizards) {
				if (curAlt === h1PrdTxt) {//so if equal we need to update it
					jQuery(this).attr('alt', 'Product Image #' + mobProImg + ' for ' + h1PrdTxt);
					//update slide count
					mobProImg++;
				}//end check for duplicate text.
			} //end mobile slides
			//related images
			if (snakes) {
				//related products
              if(curAlt.includes(curImgLinkTitle))
                {
                  curImgLinkTitle = 'related product image #' + relProImg;
                }
				/*jQuery(this).attr('alt', curImgLinkTitle ? curImgLinkTitle : 'related product image #' + relProImg);*/
              jQuery(this).attr('alt',  'related product image #' + relProImg);
				relProImg++;
			}
		imgCnt++;
	});
    relProgImg = 1;
    jQuery('#related').find('img').each(function () {
      var curImgLinkTitle = jQuery(this).parent('a').attr('title');
			
			jQuery(this).attr('alt', curImgLinkTitle ? curImgLinkTitle : 'related product image #' + relProImg);
            /*jQuery(this).attr('alt',  'related product image #' + relProImg);*/
				relProImg++;
		});
	//end updates to alternate text, title, and aria-label if needed only
  }, 4500);
  
  setTimeout(function(){
      jQuery('.flexslider').each(function(){
        //var flxPrvCnt = 1;
        //var flxNxtCnt = 1;
        var prdctTtlTxt = jQuery(this).attr('data-webcompliancepro-title');
        jQuery(this).find('.flex-prev').each(function(){
          jQuery(this).attr('aria-label','Previous Slide for '+prdctTtlTxt).attr('title','Previous Slide for '+prdctTtlTxt);
          //flxPrvCnt++;
        });
        jQuery(this).find('.flex-next').each(function(){
          jQuery(this).attr('aria-label','Next Slide for '+prdctTtlTxt).attr('title','Next Slide for '+prdctTtlTxt);
          //flxNxtCnt++;
        });
      });
    /*jQuery('.flex-prev').each(function(){
      jQuery(this).attr('aria-hidden','true').attr('tabindex','-1');
    });
    jQuery('.flex-next').each(function(){
      jQuery(this).attr('aria-hidden','true').attr('tabindex','-1');
    });*/
      /*jQuery('span.prod-title').each(function(){
        var prodAriaTxt = jQuery(this).attr('aria-label');
        var prodSpanTxt = jQuery(this).html();
        if(!prodAriaTxt || prodAriaTxt === ''){
          jQuery(this).attr('aria-label',prodSpanTxt);
        }
      });*/
      //check for tabindex
      jQuery('a').each(function(){
        var tabindexVal = jQuery(this).attr('tabindex');
        if(tabindexVal === '' || !tabindexVal){
          jQuery(this).attr('tabindex','0');
        }
      });
      jQuery('input[type="checkbox"]').each(function(){
        jQuery(this).attr('tabindex','0');
      });
      jQuery('input[type="radio"]').each(function(){
        jQuery(this).attr('tabindex','0');
      });

     
      }, 2000);
  
        setTimeout(function(){
           //fix main
      jQuery('main').attr('role','main');
      jQuery('#shopify-section-announcement').attr('role','region').attr('aria-label','Announcement Section');
      jQuery('.contact--social').each(function(){
        jQuery(this).find('a').each(function(){
          var curRole = String(jQuery(this).attr('role'));
          var curHref = String(jQuery(this).attr('href'));
          var curTabindex = String(jQuery(this).attr('tabindex'));
          if(curRole === 'img'){
            if(curHref.indexOf('facebook') > -1){
              jQuery(this).attr('aria-label','facebook icon');
            } else if(curHref.indexOf('instagram') > -1){
              jQuery(this).attr('aria-label','instagram icon');
            } else if(curHref.indexOf('tiktok') > -1){
              jQuery(this).attr('aria-label','tiktok icon');
            }
            jQuery(this).find('[role]').each(function(){
              jQuery(this).removeAttr('tabindex').removeAttr('role');
            });
          }
        });
      });
      //fix aira
          jQuery('.pagination--link').each(function(){
            jQuery(this).attr('role','button');
          });
      //fix redo button if possible
          jQuery('#redo-checkbox').find('button').each(function(){
            jQuery(this).attr('aria-label','redo button info');
          });
      //fix heading roles
          jQuery('h2').each(function(){
            jQuery(this).removeAttr('role');
          });
          jQuery('h4').each(function(){
            jQuery(this).removeAttr('role');
          });
          //fix list structures
          jQuery('.shopify-section').each(function(){
            jQuery(this).find('ul').each(function(){
            jQuery(this).find('li').each(function(){
              jQuery(this).removeAttr('role');
            });
          });
          });
           //2025-07-13
           jQuery('#redo-chat-widget').removeAttr('aria-hidden');
           jQuery('h1').removeAttr('aria-level');
           jQuery('.navigation--layout-button').each(function(){
             jQuery(this).attr('role','button');
           });
          jQuery('.acsb-sr-only').each(function(){
            jQuery(this).removeAttr('tabindex').removeAttr('role');
          });
          jQuery('button[data-target="checkbox-info-button"]').each(function(){
            jQuery(this).attr('aria-label','Information Icon');
          });
          jQuery('#sizeGuideInches').each(function(){
            jQuery(this).find('th').each(function(){
              jQuery(this).attr('scope','col');
            });
          });
          jQuery('#shopify-section-template--24132238410023__main').find('ul').each(function(){
            jQuery(this).attr('role','list');
          });
        },3500);

        //Updates 2025-12-13
        setTimeout(function(){
        $('img.needsclick').each(function(){
            var curAlt = String($(this).attr('alt'));
            if(!curAlt || curAlt === '' || curAlt === 'undefined'){
                $(this).attr('alt','');
            }
        });
        },10000);
        setTimeout(function(){
        $('[aria-controls]').each(function(){
            $(this).removeAttr('aria-haspopup');
        });
        $('.header--root').removeAttr('aria-expanded');
        $('modal-trigger').attr('role','button');
        $('.template--page').find('th').each(function(){
            $(this).attr('scope','col');
        });
        },1800);
});